export default class Navigation {

    setLastSimulation(registration, simulation) {
        Vue.prototype.$auth.setUiConfig({
            registration: {
                id: registration.id,
                cohort_id: registration.cohort_id,
                cohort: {
                    name: registration.cohort.name,
                },
                degree: {
                    name: registration.degree.name,
                },
            },
            simulation: {
                id: simulation.id,
                name: simulation.name,
            }
        }, 'last_simulation')
    }

    getLastSimulation() {
        return Vue.prototype.$auth.getUiConfig('last_simulation')
    }
}
